import { store } from 'crazyEditor/redux/store';
import { browserHistory } from 'react-router';
import _ from 'lodash';
import {adjustLocationInStore} from 'shared/components/redux/connectWithRouter';

// TODO kinda weird to add styles to a function... maybe we need a different convention for functions?
export const styles = {};

export default function updateQuery(update, replaceCurrentLocation = false) {
  const location = adjustLocationInStore(store.getState()).routing.location; // there is no proper way to get router props here, and this is never called during render
  let {query} = location;
  const {pathname} = location;
  query = {...query, ...update};
  query = _.omit(query, _.map(update, (value, key) => {
    if (value === null || value === false) {
      return key;
    }
    return null;
  }));
  if (replaceCurrentLocation) {
    browserHistory.replace({pathname, query});
  } else {
    browserHistory.push({pathname, query});
  }
}
